import React, { memo, useMemo } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { MedVoxCall } from '../../../models/MedVox/MedVoxCall';
import { formatDateTime } from '../../../utils';
import { API_URL } from '../../../utils/Constants';
import { AudioSrc } from '../../../hooks/components/useMedVoxTasks/types';
import { ERROR_STATES } from './constants';
import styles from './styles.module.css';

interface ExpandableRowElementProps {
  call: MedVoxCall;
  index: number;
  audioSrc?: AudioSrc;
}

const ExpandableRowElement: React.FC<ExpandableRowElementProps> = ({
  call,
  index,
  audioSrc,
}) => {
  const src = useMemo(() => {
    const isErrorState = ERROR_STATES.includes(call.state);
    return isErrorState || audioSrc === undefined
      ? ''
      : audioSrc[`${API_URL}api/callattempt/${call.id}/recording`];
  }, [call.state, audioSrc, call.id]);

  return (
    <div key={index} className={styles.callContainer_AudioPlayer}>
      <p>Попытка {index + 1}</p>
      <ReactAudioPlayer
        className={styles.reactAudioPlayer}
        controls
        controlsList="noplaybackrate"
        title={call.fileName.replace(/^.*[\\/]/, '')}
        src={src}
      />
      <p>{call.state}</p>
      <p className={styles.audioPlayer_time}>
        {formatDateTime(call.callDateTime)}
      </p>
    </div>
  );
};

export default memo(ExpandableRowElement);
